<template>
  <div class="row pt-2">
    <div class="col">
      <div v-if="isSauvegardeEnCours">
          <vue-loaders  name="ball-beat" class = "justify-center"></vue-loaders>
      </div>
      <div v-else class="col">
        <Button label="Sauvegarder" v-on:click="sauvegarder" />
      </div>
    </div>
    <div class="col">
      <div v-if="isSauvegardeEnCours">
        <vue-loaders  name="ball-beat" class = "justify-center"></vue-loaders>
      </div>
      <div v-else class="col">
        <div v-if="isTemporaire">
          <Button label="Recharcher narration temporaire" v-on:click="rechargerNaTemp" />
        </div>
      </div>
    </div>
    <div class="col">
      <Button label="Fermer" v-on:click="fermer"/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'ButtonBar',
  emits: ['setDialogueAfficher', 'sauvegarder', 'rechargerNaTemp', 'fermer'],
  props: ['isModifier', 'isTemporaire', 'isSauvegardeEnCours'],
  computed: {
    ...mapGetters({
      narration : 'narration/narration',
      actionAccesDecision : 'narration/actionAccesDecision',
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    })
  },
  methods: {
    fermer() {
      this.$emit('fermer');
    },
    sauvegarder(){
      this.$emit('sauvegarder');
    },
    rechargerNaTemp(){
      this.$emit('rechargerNaTemp');
    },
  }
}
</script>